import React, { useState, useEffect, memo, Suspense, lazy } from "react";
import styles from "../styles/components/Customer.module.css";
import { useTranslation } from "react-i18next";
//import homepageReview from "../utils/homepage_review.json";

const CustomerReviewPlaceholder = lazy(() => import("./CustomerReviewPlaceholder"));

function isMP4(url) {
  const extension = url.split('.').pop().toLowerCase();
  return extension === 'mp4';
}

function Customer({reviewFile}) {
  const [language, setLanguage] = useState("en");
  const { t, i18n } = useTranslation();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const currentLanguage = i18n.language;
    setLanguage(currentLanguage);
  }, [i18n.language]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        if (!reviewFile) {
          console.warn('No review file provided');
          setReviews([]);
          return;
        }
  
        const reviewData = await import(`../utils/${reviewFile}`);
        setReviews(reviewData.default || []); // default because it's a JSON module
      } catch (error) {
        console.log('Error in fetching review file: ', error);
        setReviews([]);
      }
    };
  
    fetchReviews();
  }, [reviewFile]);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t("Our Customer Says")}</h1>
        <p className={styles.bold_text}>{t("customer-listen")}</p>
      </div>
      <div className={styles.cardContainer}>
        {reviews.length === 0 ? (
          <Suspense>
            {Array.from({ length: reviews.length}).map((_, index) => (
              <CustomerReviewPlaceholder key={index} />
            ))}
          </Suspense>
        ) : (
          <Suspense>
            {reviews.map((customer) => (
              <div className={styles.card} key={customer.id}>
                {isMP4(customer.image) ? (
                  <video className={styles.image} controls muted loading="lazy">
                    <source src={customer.image} type="video/mp4" />
                  </video>
                ) : (
                  <img
                    src={customer.image}
                    alt={`${customer.name} - ${customer.location}`}
                    className={styles.image}
                    loading="lazy"
                  />
                )}
                <div className={styles.textContainer}>
                  <h3 className={styles.name}>
                    {language === "en" ? customer.name : customer.name}
                  </h3>
                  <h4 className={styles.location}>
                    {language === "en" ? customer.location : customer.location}
                  </h4>
                  <p className={styles.testimonialText}>
                    {language === "en" ? customer.comment : customer.comment}
                  </p>
                </div>
              </div>
            ))}
          </Suspense>
        )}
      </div>
    </div>
  );
}

export default memo(Customer);